
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/IndexView.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/home/IndexView.vue')
      },
      {
        path: "/about",
        name: 'about',
        component: () => import('@/views/about/IndexView.vue')
      },
      {
        path: "/join",
        name: 'join',
        component: () => import('@/views/join/IndexView.vue')
      },
      {
        path: "/news",
        name: 'news',
        component: () => import('@/views/news/IndexView.vue')
      },
      {
        path: "/resource",
        name: 'resource',
        component: () => import('@/views/resource/IndexView.vue')
      },
      {
        path: "/policy-technology",
        name: 'policy-technology',
        component: () => import('@/views/PolicyTechnology/IndexView.vue')
      },
      {
        path: "/carbon-market-tax",
        name: 'carbon-market-tax',
        component: () => import('@/views/carbon/IndexView.vue')
      },
      {
        path: "/supply-chain-carbon-footprint",
        name: "supply-chain-carbon-footprint",
        component: () => import('@/views/supplyChainFootprint/IndexView.vue')
      },
      {
        path: "/publicity-promotion",
        name: "publicity-promotion",
        component: () => import('@/views/publicityPromotion/IndexView.vue')
      },
      {
        path: "/support",
        name: "support",
        component: () => import('@/views/Support/IndexView.vue')
      },
      {
        path: "/green-finance-investment",
        name: "green-finance-investment",
        component: () => import('@/views/green/IndexView.vue')
      },
      {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: () => import('@/views/privacy/IndexVuew.vue')
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue') // 你需提前创建该组件
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

})
router.beforeEach((to, from, next) => {
  // chrome兼容
  document.body.scrollTop = 0
  // firefox兼容
  document.documentElement.scrollTop = 0
  // safari兼容
  window.pageYOffset = 0
  next()

})
export default router
